/**
 * =============================================================================
 * nav.js
 * =============================================================================

 * =============================================================================
 */

var Nav = {
  headerSectionElement: null,

  init: function() {
    this.headerSectionElement = document.querySelector('.section-header');
    this.setupScrollListener();
    document.addEventListener('interaction:down-scroll', this.onScrollDown.bind(this));
    document.addEventListener('interaction:up-scroll', this.onScrollUp.bind(this));
  },

  onScrollDown: function(e) {
    if(e.detail.difference > 5) {
      this.headerSectionElement.classList.remove('scrolled-up');
      this.headerSectionElement.classList.add('scrolled-down');
    }
  },

  onScrollUp: function(e) {
    if(e.detail.difference > 5) {
      this.headerSectionElement.classList.remove('scrolled-down');
      this.headerSectionElement.classList.add('scrolled-up');
    }
  },

  setupScrollListener: function() {
    var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    window.addEventListener("scroll", function(e){
      var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      var difference = Math.abs(st - lastScrollTop);
      // Add a 'tolerance' to prevent microscrolls from retriggering (e.g. on touch devices, there's usually a very small scroll up after scrolling down)
      if (st > lastScrollTop){
        var event = new CustomEvent("interaction:down-scroll", {
          detail: {
            difference: difference
          }
        });
        document.dispatchEvent(event);
      } else {
        var event = new CustomEvent("interaction:up-scroll", {
          detail: {
            difference: difference
          }
        });
        document.dispatchEvent(event);
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);
  }
}

export default Nav;